export const inr = (n, opts = {}) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  const num = Number(n);
  if (opts.compact && Math.abs(num) >= 100000) {
    if (Math.abs(num) >= 10000000) return `₹${(num / 10000000).toFixed(2)} Cr`;
    return `₹${(num / 100000).toFixed(2)} L`;
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    maximumFractionDigits: 0,
  }).format(num);
};

export const inrPlain = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return new Intl.NumberFormat("en-IN", { maximumFractionDigits: 0 }).format(Number(n));
};

export const num = (v) => (v === "" || v === null || v === undefined ? 0 : Number(v));
